module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#facebook",
      toString: function () {
        return this.url;
      }
    }